module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av281-18bcd968dfa4c64a07277d8920665896.jpg";